RA.SearchBar = {
  init: function() {
    this.setVariables();
    this.bindEvents();
    this.initDock();
  },
  setVariables: function() {
    this.$queryInput = $(".main-search__input");
    this.$searchForm = $(".main-search__form");
    this.searchDockEnabled = true;
    this.isResultsPage = false;
    this.currentQueryText = this.$queryInput.val();
    this.lastQueryText = this.currentQueryText;
  },
  bindEvents: function() {
    this.$searchForm .on("submit.ra.searchBar", $.proxy(this.formSubmitted, this));
    this.$queryInput.on("keydown.ra.searchBar", $.proxy(this.keyPressed, this));
  },
  setSearchText: function(text) {
    this.$queryInput.val(text);
  },
  search: function(event) {
    if (this.isResultsPage) {
      RA.ResultsPage.queryTextUpdated(event);
    } else {
      if (RA.Utils.isBlank(this.$queryInput.val())) {
        this.focusInput();
        return;
      }

      this.goToResultsPage(event);
    }
  },
  goToResultsPage: function(event) {
    var queryText = this.$queryInput.val();

    var extraParams = {};
    var setKBTab, setCommunityTab = false;
    if (event) {
      if (event.source == "community") {
        setCommunityTab = true;
      }

      if (event.source == "kb") {
        setKBTab = true;
      }

      if (event.community) {
        extraParams.communityID = event.community.id;
        setCommunityTab = true;
      }

      if (event.topic) {
        extraParams.topicID = event.topic.id;
        setCommunityTab = true;
      }
    }

    var searchUrl = RA.buildSearchUrl(queryText, extraParams);
	searchUrl += simplifiedSocialLayoutParam;
	searchUrl += launchLinksInNewWindowParam;

    if (setKBTab) {
      searchUrl += "#t=kbResults";
    } else if (setCommunityTab) {
      searchUrl += "#t=commResults";
    }

    //console.log(searchUrl);
    location.href = searchUrl;
  },
  focusInput: function() {
    var $queryInput = this.$queryInput;

    $queryInput.focus();

    if (!$queryInput.hasClass("-error")) {
      $queryInput.addClass("-error");

      setTimeout(function() {
        $queryInput.removeClass("-error");
      }, 3000);
    }
  },
  initAutocomplete: function() {
    if (!window.autocomplete) return;
    if (!Config.autoSearchEnabled) return;

    var lastQuery = "";
    var searchesCallback, kbCallback, communityCallback;

    // debounce to rate-limit server requests
    var getSuggestions = debounce(function(query) {
      if (query.length < 3) return;
      lastQuery = query;

      var data = {
        querytext: query,
        doKBSearches: true,
        doKBSolutions: true,
        doCommunityDiscussions: Config.isCommunityEnabled
      };

      $.get(Config.contextPath + "/controller/searchsuggestions/", data)
        .done(function(r) {
          // show context & searches
          var searchItems = getContextSuggestions(query);
          searchItems = searchItems.concat(r.kbSearches.slice(0, 5));
          searchesCallback(searchItems, query);

          // show KB solutions
          kbCallback(r.kbSolutions.slice(0, 3), query);

          // show community discussions
          communityCallback(r.communityDiscussions.slice(0, 3), query);
        })
        .fail(function() {
          this.$queryInput.autocomplete.destroy();
        }.bind(this))
    }.bind(this), 800);

    // community context suggestions
    var getContextSuggestions = function(query) {
      var items = [];

      if (!Config.isCommunityEnabled) {
        return items;
      }

      if (!this.isResultsPage) {
        var context = RA.getCommunityContext();
        if (context.community && context.community.id) {
          items.push({suggestion: query, community: context.community});
        }

        if (context.topic && context.topic.id) {
          items.push({suggestion: query, community: context.community, topic: context.topic});
        }
      }

      return items;
    }.bind(this);

    // main server source
    // using 1 server call to populate suggestions other sources
    // this source never uses its callback
    var serverSource = function(query) {
      var isChanged = $.trim(lastQuery) != $.trim(query)

      if (isChanged) {
        getSuggestions(query);
      }
    };

    // searches source
    var searchesSource = function(query, callback) {
      // used in getSuggestions
      searchesCallback = callback;
    }

    // kb source
    var kbSource = function(query, callback) {
      // used in getSuggestions
      kbCallback = callback;
    }

    // community source
    var communitySource = function(query, callback) {
      // used in getSuggestions
      communityCallback = callback;
    };

    var hightlightQueryWords = function(value, query) {
      query = query || "";
      var words = query.split(/\s/);

      words.forEach(function(word) {
        value = value.replace(word, "<em>" + word + "</em>");
      });

      return value;
    };

    var searchesTemplates = {
      header: function() {
        return "<div class='aa-dataset-header'>"
          + "<span class='glyphicon glyphicon-search'></span> "
          + Labels.getLabel("Search Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        if (obj.topic) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + " &gt; " + obj.topic.name + "</span></div>";
        } else if (obj.community) {
          return "<div>" + obj.suggestion + " in <span class='aa-suggestion__ctx'>" + obj.community.name + "</span></div>";
        } else {
          return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
        }
      }
    }

    var kbTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -kb'>"
          + "<span class='glyphicon glyphicon-book'></span> "
          + Labels.getLabel("Knowledgebase Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    }

    var communityTemplates = {
      header: function() {
        return "<div class='aa-dataset-header -comm'>"
          + "<span class='glyphicon glyphicon-comment'></span> "
          + Labels.getLabel("Community Suggestions")
          + "</div>";
      },
      suggestion: function(obj, query) {
        return "<div>" + hightlightQueryWords(obj.suggestion, query) + "</div>";
      }
    };

    // init the plugin
    // jQuery version of this plugin conflicts with a jQueryUI plugin
    // with the same name - so using global function version instead
    var $plugIn = autocomplete(".main-search__input",
      {
        hint: false
      },
      [
        {
          source: serverSource
        },
        {
          source: searchesSource,
          name: "search",
          displayKey: "suggestion",
          templates: searchesTemplates
        },
        {
          source: kbSource,
          name: "kb",
          displayKey: "suggestion",
          templates: kbTemplates
        },
        {
          source: communitySource,
          name: "community",
          displayKey: function(obj) {
            return obj.community ? obj.value : obj.suggestion;
          },
          templates: communityTemplates
        }
      ]
    );

    // plugin event handlers
    $plugIn.on("autocomplete:selected", function(e, value, name) {
      var eventData = { type: "autocomplete", value: value.suggestion, source: name };
      if (value.community) eventData.community = value.community;
      if (value.topic) eventData.topic = value.topic;
      this.search(eventData);
    }.bind(this));

    // store reference to plugin function on $queryInput
    this.$queryInput.autocomplete = $plugIn.autocomplete;
  },
  initDock: function() {
    this.$mainSearch = $(".main-search");
    this.$placeHolder = $("<div />");

    if (!this.$mainSearch.length) {
      return;
    }

    var initBottom = this.$mainSearch.offset().top + this.$mainSearch.outerHeight();

    this.$placeHolder.css({ display: "none",
      height: this.$mainSearch.outerHeight() });
    this.$mainSearch.after(this.$placeHolder);

    var $window = $(window);
    $window.on("scroll", function() {
      if (initBottom - $window.scrollTop() < 0) {
        this.dockSearch();
      } else {
        this.undockSearch();
      }
    }.bind(this));

    $window.on("resize", debounce(function() {
      this.undockSearch();
    }.bind(this), 50));
  },
  dockSearch: function() {
    if (!this.searchDockEnabled) return;

    this.$mainSearch.addClass("-docked");
    this.$placeHolder.css("display", "block");
  },
  undockSearch: function() {
    this.$mainSearch.removeClass("-docked");
    this.$placeHolder.css("display", "none");
  },
  keyPressed: function(e) {
    if (e.keyCode == 13) {
      this.lastQueryText = this.$queryInput.val();
      return;
    }

    if (this.isResultsPage) {
      RA.ResultsPage.queryTextUpdating();

      clearTimeout(this.keyPressTimeout);
      this.keyPressTimeout = setTimeout(this.keyPressSearch.bind(this), 1000);
    }
  },
  keyPressSearch: function() {
    var currentQueryText = this.$queryInput.val();

    if (this.lastQueryText.trim() !== currentQueryText.trim()) {
      this.lastQueryText = currentQueryText;

      var eventData = { type: "keypress", value: currentQueryText };
      this.search(eventData);
    }
  },
  formSubmitted: function(e) {
    clearTimeout(this.keyPressTimeout);
    this.lastQueryText = this.$queryInput.val();

    var eventData = { type: "submit", value: this.$queryInput.val() };

    if (this.isResultsPage && this.$queryInput.autocomplete && Config.autoSearchEnabled) {
      this.$queryInput.autocomplete.close();
    }

    this.search(eventData);
    return false;
  }
};
